import { Box } from '@global-engineering-shared/gweb-material-ui';
import React from 'react';

import Filter from 'components/Filter/Filter';
import PaginatedItemsProvider from 'context/PaginatedItems/context/PaginatedItemsProvider';
import { useSearchParamsProvider } from 'context/SearchParamsProvider/SearchParamsProvider';
import FramesTable from 'features/Frames/components/Frames/FramesTable';
import SearchPageTableHeader from 'features/Search/components/SearchPageTableHeader';
import useStyles from 'features/Search/pages/SearchPage/SearchPage.styles';
import { addFiltersToUrl } from 'utils/addFiltersToUrl';
import { FRAMES_TABLE_PAGE_SIZE } from 'utils/defaults';
import { SEARCH_API_URL } from 'utils/environmentVariables';

const SEARCH_TERM = 'searchTerm';

const SearchPage = () => {
  const classes = useStyles();

  const { searchParams } = useSearchParamsProvider();
  const searchTerm = searchParams.get(SEARCH_TERM);

  const url = addFiltersToUrl(SEARCH_API_URL, searchParams, 'searchTerm', searchTerm);

  const headerSupplier = (totalItems: number) => (
    <SearchPageTableHeader searchTerm={searchTerm} numberOfResults={totalItems} />
  );

  return (
    <main>
      <Filter></Filter>
      <Box className={classes.wrapper}>
        <PaginatedItemsProvider pageableUrl={url} pageSize={FRAMES_TABLE_PAGE_SIZE}>
          <Box>
            <FramesTable
              idSuffix={'search'}
              headerSupplier={headerSupplier}
              showHeaderIfEmpty={true}
            />
          </Box>
        </PaginatedItemsProvider>
      </Box>
    </main>
  );
};

export default SearchPage;
